import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { IApplicationState } from '../../combiners'
import { updateLanguage } from '../actions'
import { navigate } from 'hookrouter'

export const useSetLanguage = (language: string) => {
  const { currentLanguage, defaultLanguage, isAvailableLanguage, hasDoneFirstRun } = useSelector(
    createSelector(
      (state: IApplicationState) => state.locale,
      (state: IApplicationState) => state.menu,
      ({ currentLanguage, defaultLanguage, availableLanguages, texts }) => ({
        currentLanguage,
        defaultLanguage,
        isAvailableLanguage: (language: string) => {
          return availableLanguages.filter((lang) => lang.code === language).count() > 0
        },
        hasDoneFirstRun: availableLanguages.filter((lang) => lang.code === currentLanguage).count() > 0
      })
    )
  )

  const dispatch = useDispatch()

  useEffect(() => {
    if (currentLanguage !== language) {
      if (isAvailableLanguage(language)) {
        dispatch(updateLanguage(language))
      } else {
        navigate(`/${defaultLanguage}`)
      }
    }
  }, [isAvailableLanguage, currentLanguage, defaultLanguage, language, dispatch])

  return hasDoneFirstRun
}
